import moment from 'moment'
import { scoreOverTime, scoreBreakdown } from './charts'
import * as scoreHierarchy from '../scoreHierarchy'
import sectionLabels from '../sectionLabels'
import lodash from 'lodash'
import presignedExport from '../../../services/auth/presignedExport';

angular.module('clientDashboardApp').controller("ScoreSummaryCtrl",
  (
    $scope, $timeout,
    locationService,
    scoreResultsService,
    sharedScoringReportFilters
    ) => {

    // document.querySelector("contentArea").classList.add("width-control");

    $scope.onDateRangeChanged = ({start, end}) => {
      Object.assign($scope.searchConfig, {start, end});
    }

    $scope.brandConfigRestrictions = {};

    $scope.loadingResults = true
    $scope.theBillingAccountId = $scope.userInfo.billingAccountId

    $scope.searchConfig = sharedScoringReportFilters.restoreFilters()

    const refreshScoreBreakdown = () => $scope.toggleScoreBreakdownTab(0)

    $scope.isActiveCategory = cat => {
      return cat === $scope.activeScore
    }
    $scope.isActiveSubcategory = cat => {
      return cat === $scope.activeScoreComponent
    }

    $scope.toggleScoreBreakdownTab = (tabId) => {
      let scrollY = window.scrollY;
      $scope.activeScore = $scope.scores[tabId];
      $scope.selectScoreComponent();
      window.scrollTo(0, scrollY);
    }

    $scope.selectScoreComponent = (component) => {
      let scrollY = window.scrollY;
      $scope.activeScoreComponent = component;
      if(component){
        $scope.scoreBreakdownGraph(component.scorePath, component.value);
      }else{
        $scope.scoreBreakDownAllGraph($scope.activeScore.components[0].scorePath, $scope.activeScore.components)
      }

      window.scrollTo(0, scrollY);
    }

    $scope.scoreBreakdownGraph = (path, sectionHistory) => {
      const config = scoreBreakdown(path, [lodash.zip($scope.scoreOverTimePeriods, sectionHistory)], "line");
      renderHighchartWhenElementAvailable(
        'scoreBreakdownLineGraph',
        config
      )
    };
    $scope.scoreBreakDownAllGraph = (path, scoreHistory) => {
      let data = scoreHistory.map(component => {
        let data = lodash.zip( $scope.scoreOverTimePeriods, component.value);
        data.name = component.name;
        return data
      });
      const config = scoreBreakdown(path, data, "line");
      renderHighchartWhenElementAvailable(
        'scoreBreakdownLineGraph',
        config
      )
    }

    let isExporting = false;
    $scope.export = () => {
      if (!isExporting) {
        isExporting = true
        const { start, end, groupId} = $scope.searchConfig
        return presignedExport.downloadExport('/v5/scores/exportSegments', {
          end: end.toDate(),
          groupId,
          start: start.toDate(),
          scorePaths: scoreHierarchy.withDescendants('total')
        }).finally(x => isExporting = false)
      }
    }

    const search = () => {
      $scope.loadingResults = true;
      const allPaths = scoreHierarchy.withDescendants('total', 3);
      const {start, end, groupId} = $scope.searchConfig;

      return Promise.all([
        scoreResultsService.timelineSegments({
          start: (() => {
            // show at least one week in the timeline graph (IIFE to scope logic where needed)
            const weekBefore = moment(end).subtract(7, 'days');
            const atLeastWeekBefore = start.isAfter(weekBefore) ? weekBefore : start;
            return atLeastWeekBefore.toDate();
          })(),
          end: end.toDate(),
          groupId,
          scorePaths: allPaths
        }),
        scoreResultsService.overallAverages({
          start: start.toDate(),
          end: end.toDate(),
          groupId,
          scorePaths: allPaths
        })
      ])
        .then(([
          timelineSegments,
          overallAverages
        ]) => {
          try {
            const topLevels = scoreHierarchy.withDescendants('total', 2);

            /** munge data into shape for the chart over time and score breakdowns*/
            const timelineSegmentsByScorePath = timelineSegments.values.reduce((sum, x) => ({
              ...sum,
              [x.scorePath]: x
            }), {})

            // x axis date labels for the graphs. type is Number[] - an array of milliseconds since epoch
            $scope.scoreOverTimePeriods = timelineSegments.segmentDates.map(segment => new Date(segment + (new Date(segment).getTimezoneOffset() * 60 * 1000)).valueOf());

            // passed to highcharts for the primary graph
            $scope.toplevelGraphs = scoreHierarchy
              .withDescendants('total', 2)
              .map(id => timelineSegmentsByScorePath[id]);

            // tree structured models for the breakdown graph below the primary graph
            const toNestedScore = scorePath => {
              if (scorePath in timelineSegmentsByScorePath) {
                return ({
                  name: sectionLabels[scorePath],
                  scorePath: scorePath,
                  value: timelineSegmentsByScorePath[scorePath].segments,
                  components: (scoreHierarchy.tree[scorePath] || []).map(x => toNestedScore(x)).filter(x => x)
                });
              } else {
                return undefined
              }
            }

            $scope.scores = scoreHierarchy.tree['total'].map(scorePath => toNestedScore(scorePath));

            /** munge data into shape for the overall average score cards */
            const overallAveragesByScorePath = overallAverages.values.reduce((sum, el) => ({
              ...sum,
              [el.scorePath]: el
            }), {});

            // for the cards up top
            $scope.cardSummaries = topLevels.map(scorePath => {
              const el = overallAveragesByScorePath[scorePath]
              // if there's no recent average scores for the selected timeline,
              // just fall back to the latest score instead of an average
              // (happens for demos that aren't run regularly, or if scoring is down)
              const latestTimelineSegment = timelineSegmentsByScorePath[scorePath].segments.slice().reverse().find(x => x !== null)
              const number = el.current || latestTimelineSegment
              const value = number && Math.round(number * 100);

              return {
                label: sectionLabels[scorePath],
                value: value,
                delta: el.deltaRatio && (Math.round(el.deltaRatio * 100) / 100)
              }
            });

            // If true, we have no data at all for the selected time frame
            // so we must retrieve the latest counts and use that data, instead
            if(shouldBackfillData()) {
              backfillData(end, groupId, allPaths)
            } else {
              $scope.loadingResults = false;
              drawScoreOverTimeLineGraph()
              refreshScoreBreakdown()
            }
          } catch (e) {
            console.error('kablam', e)
            throw e
          }
        })
    }


    $scope.chartType = 'line'
    $scope.setChartType = (type) => {
      $scope.chartType = type
      drawScoreOverTimeLineGraph()
    }

    const drawScoreOverTimeLineGraph = () => {
      // Display a marker if there is only one data point (no line can be made from a single point)
      const config = scoreOverTime(
        $scope.toplevelGraphs || [],
        $scope.scoreOverTimePeriods,
        $scope.chartType
      )
      renderHighchartWhenElementAvailable(
        'scoreOverTimeLineGraph',
        config
      )
    }

    const renderHighchartWhenElementAvailable = (id, config) => {
      // TODO this is leaking resources and the code is duplicated
      let element = document.getElementById(id);
      if (element && element.clientWidth !== 0) {
        // only render the graph once the container has been drawn into shape
        // (hence waiting element.clientWidth has a non-zero value)
        Highcharts.chart(id, config)
      } else {
        $timeout(() => {
          renderHighchartWhenElementAvailable(id, config)
        }, 50)
      }
    }

    const shouldBackfillData = () => {
      for(let i = 0; i < $scope.toplevelGraphs.length; i++) {
        if($scope.toplevelGraphs[i].segments.every(element => element === null)) {
          return true;
        }
      }

      return false
    }

    /**
     * Fills in null data with the latest scores.
     *
     * This is important for both demo accounts AND initial load of the report...
     *
     * @param end - The end date of the search parameter
     * @param groupId - The groupId to retrieve the results for
     * @param allPaths - All of the paths to retrieve
     */
    const backfillData = (end, groupId, allPaths) => {
      Promise.all([
        scoreResultsService.timelineSegments({
          start: moment("1970-01-01").toDate(),
          end: end.toDate(),
          groupId,
          scorePaths: allPaths
        })
      ]).then(([latestSegments]) => {
        let hashedValues = new Map();

        // Get the latest point for every score and score breakdown. Hash on the path
        for(let i = 0; i < latestSegments.values.length; i++) {
          if (latestSegments.values[i].segments.filter(x => x !== null).length <= 0) { // If no scoring exists at all; exit
            $scope.hasValidData = false;
          } else {
            $scope.hasValidData = true;
            hashedValues.set(generateStringHash(latestSegments.values[i].scorePath), latestSegments.values[i].segments.filter(x => x !== null).pop())
          }
        }

        // Replace null overall scores with latest values
        $scope.toplevelGraphs[0].segments = $scope.toplevelGraphs[0].segments.map(segment => segment !== null ? segment : hashedValues.get(generateStringHash("total"))) // Replace any null values with the latest score
        if ($scope.cardSummaries[0].value == null || $scope.cardSummaries[0].value == 0) {
          $scope.cardSummaries[0].value = Math.round(hashedValues.get(generateStringHash("total")) * 100) // Convert decimal to percentage
        }
        if ($scope.cardSummaries[0].delta == null) {
          $scope.cardSummaries[0].delta = 0.00 // No change within viewed timeframe
        }

        // Replace null review scores with latest values
        $scope.toplevelGraphs[1].segments = $scope.toplevelGraphs[1].segments.map(segment => segment !== null ? segment : hashedValues.get(generateStringHash("reviews"))) // Replace any null values with the latest score
        $scope.scores[0].components[0].value = $scope.scores[0].components[0].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("reviews.rating")))
        $scope.scores[0].components[1].value = $scope.scores[0].components[1].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("reviews.growth")))
        $scope.scores[0].components[2].value = $scope.scores[0].components[2].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("reviews.response")))
        $scope.scores[0].components[3].value = $scope.scores[0].components[3].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("reviews.sentiment")))
        if ($scope.cardSummaries[1].value == null || $scope.cardSummaries[1].value == 0) {
          $scope.cardSummaries[1].value = Math.round(hashedValues.get(generateStringHash("reviews")) * 100) // Convert decimal to percentage
        }
        if ($scope.cardSummaries[1].delta == null) {
          $scope.cardSummaries[1].delta = 0.00 // No change within viewed timeframe
        }

        // Replace null social scores with latest values
        $scope.toplevelGraphs[2].segments = $scope.toplevelGraphs[2].segments.map(segment => segment !== null ? segment : hashedValues.get(generateStringHash("social")))
        $scope.scores[1].components[0].value = $scope.scores[1].components[0].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("social.posts")))
        $scope.scores[1].components[1].value = $scope.scores[1].components[1].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("social.fans")))
        $scope.scores[1].components[2].value = $scope.scores[1].components[2].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("social.tags")))
        if ($scope.cardSummaries[2].value == null || $scope.cardSummaries[2].value == 0) {
          $scope.cardSummaries[2].value = Math.round(hashedValues.get(generateStringHash("social")) * 100) // Convert decimal to percentage
        }
        if ($scope.cardSummaries[2].delta == null) {
          $scope.cardSummaries[2].delta = 0.00 // No change within viewed timeframe
        }

        // Replace null review listing with latest values
        $scope.toplevelGraphs[3].segments = $scope.toplevelGraphs[3].segments.map(segment => segment !== null ? segment : hashedValues.get(generateStringHash("listings"))) // Replace any null values with the latest score
        $scope.scores[2].components[0].value = $scope.scores[2].components[0].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("listings.accuracy")))
        $scope.scores[2].components[1].value = $scope.scores[2].components[1].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("listings.url")))
        $scope.scores[2].components[2].value = $scope.scores[2].components[2].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("listings.duplicates")))
        if ($scope.cardSummaries[3].value == null || $scope.cardSummaries[3].value == 0) {
          $scope.cardSummaries[3].value = Math.round(hashedValues.get(generateStringHash("listings")) * 100) // Convert decimal to percentage
        }
        if ($scope.cardSummaries[3].delta == null) {
          $scope.cardSummaries[3].delta = 0.00 // No change within viewed timeframe
        }

        // Replace null ranking scores with latest values
        $scope.toplevelGraphs[4].segments = $scope.toplevelGraphs[4].segments.map(segment => segment !== null ? segment : hashedValues.get(generateStringHash("rankings"))) // Replace any null values with the latest score
        $scope.scores[3].components[0].value = $scope.scores[3].components[0].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("rankings.search")))
        $scope.scores[3].components[1].value = $scope.scores[3].components[1].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("rankings.insights")))
        if ($scope.cardSummaries[4].value == null || $scope.cardSummaries[4].value == 0) {
          $scope.cardSummaries[4].value = Math.round(hashedValues.get(generateStringHash("rankings")) * 100) // Convert decimal to percentage
        }
        if ($scope.cardSummaries[4].delta == null) {
          $scope.cardSummaries[4].delta = 0.00 // No change within viewed timeframe
        }

        // Replace null competitor scores with latest values
        $scope.toplevelGraphs[5].segments = $scope.toplevelGraphs[5].segments.map(segment => segment !== null ? segment : hashedValues.get(generateStringHash("competitors"))) // Replace any null values with the latest score
        $scope.scores[4].components[0].value = $scope.scores[4].components[0].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("competitors.reviews")))
        $scope.scores[4].components[1].value = $scope.scores[4].components[1].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("competitors.responses")))
        $scope.scores[4].components[2].value = $scope.scores[4].components[2].value.map(value => value !== null ? value : hashedValues.get(generateStringHash("competitors.social")))
        if ($scope.cardSummaries[5].value == null || $scope.cardSummaries[5].value == 0) {
          $scope.cardSummaries[5].value = Math.round(hashedValues.get(generateStringHash("competitors")) * 100) // Convert decimal to percentage
        }
        if($scope.cardSummaries[5].delta == null) {
          $scope.cardSummaries[5].delta = 0.00 // No change within viewed timeframe
        }

        $scope.loadingResults = false;
        drawScoreOverTimeLineGraph()
        refreshScoreBreakdown()
      })
    }

    const generateStringHash = (str) => {
      var hash = 0, i, chr;

      if(str.length === 0) {
        return hash;
      }

      for(var i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash = hash & hash; // Convert to 32 bit integer
      }

      return hash
    }

    const init = () => {

      search()
        .then(() => {
          // use $watchCollection to avoid some of the shittiness of normal $watch
          // - normal $watch is fired once initially
          // $watchCollection also makes sense b/c it does a shallow equals on the search config properties
          $scope.$watchCollection(sc => Object.values(sc.searchConfig), (a, b) => {
            if (!lodash.isEqual(a, b)) {
              sharedScoringReportFilters.persistFilters($scope.searchConfig)
              search()
            }
          })

          $scope.$watch(() => locationService.getSelectedGroupId(), (groupId) => {
            $scope.searchConfig.groupId = groupId
          }, true)
        })
    }

    init()
  })
